// CAF receiver bootstrap. Loaded only when running inside a Chromecast or
// AirPlay surface. Listens for a custom message namespace
// 'urn:x-cast:com.trivia.party' from the host phone carrying:
//   { type: 'JOIN_ROOM', roomId: string, token: string }
//
// In non-Cast browsers this is a no-op; the receiver also accepts the same
// data via hash routing for direct preview / tvOS / Android TV pairing.

type JoinPayload = { type: 'JOIN_ROOM'; roomId: string; token: string };

const NAMESPACE = 'urn:x-cast:com.trivia.party';

export type OnJoin = (payload: JoinPayload) => void;

interface CafCastReceiverContext {
  getInstance(): CafCastReceiverContext;
  addCustomMessageListener(ns: string, fn: (e: { data: unknown }) => void): void;
  start(opts: unknown): void;
}

interface CafGlobal {
  cast?: { framework?: { CastReceiverContext: CafCastReceiverContext } };
}

const CAF_SDK_URL =
  'https://www.gstatic.com/cast/sdk/libs/caf_receiver/v3/cast_receiver_framework.js';

export function initCastReceiver(onJoin: OnJoin): void {
  const w = window as unknown as CafGlobal;

  // If we're not inside a Cast frame, the SDK won't load — that's OK.
  const script = document.createElement('script');
  script.src = CAF_SDK_URL;
  script.async = true;
  script.onload = () => {
    const ctx = w.cast?.framework?.CastReceiverContext?.getInstance();
    if (!ctx) return;
    ctx.addCustomMessageListener(NAMESPACE, (event: { data: unknown }) => {
      const data = event.data as Partial<JoinPayload> | undefined;
      if (data?.type === 'JOIN_ROOM' && data.roomId && data.token) {
        onJoin(data as JoinPayload);
      }
    });
    ctx.start({});
  };
  script.onerror = () => {
    // Not on Cast; ignore.
  };
  document.head.appendChild(script);
}
